import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    Output
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import * as fromShared from '../../shared';
import { SelectItem } from '../../shared';
import { IUserInfo } from '../../user-info';

@Component({
    selector: 'ef-manage-users-bulk-update-presenter',
    templateUrl: './manage-users-bulk-update-presenter.component.html',
    styleUrls: ['./manage-users-bulk-update-presenter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ManageUsersBulkUpdatePresenterComponent implements OnInit {
    @Input() userInfo: IUserInfo;
    @Input() daysOfWeek: fromShared.SelectItem[];
    @Input() costCenters: fromShared.SelectItem[];
    @Input() timeZones: fromShared.SelectItem[];
    @Input() userIdFormats: fromShared.SelectItem[];
    @Input() updateEnabled: boolean;
    @Output() UpdateBulkLogins = new Subject<any>();
    public tabLogins;
    public bulkFormGroup: UntypedFormGroup;
    public holidayAuthOptions: SelectItem[] = [
        { label: 'Yes', value: '1' },
        { label: 'No', value: '0' },
        { label: 'Unchanged', value: '' }
    ];
    visible = false;
    constructor() {
        this.bulkFormGroup = new UntypedFormGroup({
            EPassword: new UntypedFormControl(),
            AuthorizedHolidays: new UntypedFormControl(),
            CostCenterID: new UntypedFormControl(),
            UserIDFormat: new UntypedFormControl(),
            FirstDayofWeekID: new UntypedFormControl(),
            EmpTimeZone: new UntypedFormControl(),
            Expectedhrsperday: new UntypedFormControl(),
            Expectedhrsperweek: new UntypedFormControl()
        });
    }

    ngOnInit(): void {}

    showDialog(event: any) {
        event.stopPropagation();
        this.visible = true;
    }
}
